import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const categoryImages: Record<string, string> = {
  'wanghong-fanche': 'https://readdy.ai/api/search-image?query=Dramatic%20moment%20of%20Chinese%20live%20streamer%20expression%20change%2C%20dark%20studio%20background%20with%20neon%20lights%2C%20tense%20atmosphere%2C%20editorial%20cinematic%20style%2C%20high%20contrast%20warm%20tones&width=600&height=400&seq=chigua-cat-wanghong&orientation=landscape',
  'yule-bagua': 'https://readdy.ai/api/search-image?query=Entertainment%20news%20red%20carpet%20event%20with%20celebrities%20and%20flashing%20cameras%2C%20glamorous%20Chinese%20entertainment%20industry%20scene%2C%20warm%20golden%20lighting%2C%20editorial%20style&width=600&height=400&seq=chigua-cat-yule&orientation=landscape',
  'heila-baoliao': 'https://readdy.ai/api/search-image?query=Mysterious%20documents%20and%20photos%20scattered%20on%20dark%20wooden%20desk%2C%20dramatic%20shadow%20and%20light%2C%20investigative%20journalism%20theme%2C%20warm%20dark%20tones%2C%20cinematic%20noir%20style&width=600&height=400&seq=chigua-cat-heila&orientation=landscape',
  'jieri-dagua': 'https://readdy.ai/api/search-image?query=Fresh%20watermelon%20slices%20with%20newspaper%20background%2C%20bright%20red%20and%20green%2C%20clean%20minimal%20food%20photography%2C%20summer%20vibe%2C%20warm%20natural%20lighting%2C%20editorial%20style&width=600&height=400&seq=chigua-cat-riji&orientation=landscape',
  'zhibo-fanche': 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20ring%20light%20and%20smartphone%2C%20modern%20broadcasting%20equipment%2C%20warm%20atmosphere%2C%20professional%20streamer%20workspace%2C%20clean%20editorial%20style&width=600&height=400&seq=chigua-cat-zhibo&orientation=landscape',
  'shejiao-reshi': 'https://readdy.ai/api/search-image?query=Social%20media%20feeds%20and%20trending%20topics%20visualized%20artistically%2C%20smartphone%20with%20floating%20notification%20icons%2C%20warm%20modern%20digital%20concept%2C%20clean%20editorial%20style&width=600&height=400&seq=chigua-cat-shejiao&orientation=landscape',
};

export default function HotCategories() {
  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-8">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
            热门吃瓜分类
          </h2>
          <p className="text-foreground-500 text-sm mt-1">按你的口味挑选想吃的瓜</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden h-32 md:h-40 cursor-pointer"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={`${cat.name} - 吃瓜官网`}
                title={`${cat.name} - 吃瓜官网热门分类`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <div className="w-6 h-6 flex items-center justify-center mb-1">
                  <i className={`${cat.icon} text-background-50 text-sm`}></i>
                </div>
                <p className="text-background-50 font-heading font-semibold text-sm">{cat.name}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}